import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { LangProvider } from "./lib/i18n";
import { Nav, scrollToId } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { BeforeAfter } from "./components/BeforeAfter";
import { Skincare } from "./components/Skincare";
import { Reviews } from "./components/Reviews";
import { GiftCards } from "./components/GiftCards";
import { Booking } from "./components/Booking";
import { Contact } from "./components/Contact";
import { Footer, WhatsAppFab } from "./components/Footer";
import Privacy from "./pages/Privacy";
import ThankYou from "./pages/ThankYou";
import ReviewRequest from "./pages/ReviewRequest";
import Referral from "./pages/Referral";
import SkinQuiz from "./pages/SkinQuiz";
import Treatment from "./pages/Treatment";
import Shop from "./pages/Shop";
import AdminApp from "./pages/admin/AdminApp";
import { ContentProvider } from "./lib/content";
import { ReferralBand } from "./components/ReferralBand";
import { ReferralCapture } from "./lib/referral";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import { JournalTeaser } from "./components/JournalTeaser";
import { InstagramStrip } from "./components/InstagramStrip";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";
import GlowGift from "./pages/GlowGift";
import BeautyCentre from "./pages/BeautyCentre";
import { GLOW_PATH } from "./lib/season";
import { useSeo } from "./lib/seo";

const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (time) => { lenis.raf(time); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);
};

function Home() {
  const [picked, setPicked] = useState("");
  const { hash, state } = useLocation();
  useSeo("Centro estetico a Catanzaro · Gioia Centro Estetico", "Gioia Centro Estetico a Catanzaro: lipolaser, mesoterapia e mesoporazione estetica, trattamenti viso pro-age, corpo snellente, depilazione laser, manicure. 4,8 su Google.");
  useEffect(() => {
    if (state?.service) setPicked(state.service);
  }, [state]);
  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 600);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services onPick={setPicked} />
        <BeforeAfter />
        <Skincare />
        <Reviews />
        <JournalTeaser />
        <GiftCards />
        <ReferralBand />
        <Booking picked={picked} />
        <InstagramStrip />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

const PublicFab = () => (useLocation().pathname.startsWith("/admin") ? null : <WhatsAppFab />);

function App() {
  useLenis();
  return (
    <LangProvider>
      <ContentProvider>
      <BrowserRouter>
        <div className="App" data-testid="app-root">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/grazie" element={<ThankYou />} />
            <Route path="/richiedi-recensione" element={<ReviewRequest />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/porta-un-amica" element={<Referral />} />
            <Route path="/quiz-pelle" element={<SkinQuiz />} />
            <Route path="/trattamenti/:slug" element={<Treatment />} />
            <Route path="/shop" element={<Shop />} />
            <Route path={GLOW_PATH} element={<GlowGift />} />
            <Route path="/centro-estetico-catanzaro" element={<BeautyCentre />} />
            <Route path="/admin/*" element={<AdminApp />} />
          </Routes>
          <ReferralCapture />
          <PublicFab />
          <Toaster position="bottom-center" />
        </div>
      </BrowserRouter>
      </ContentProvider>
    </LangProvider>
  );
}

export default App;
